import { render, staticRenderFns } from "./115wsdbpfyh.vue?vue&type=template&id=4fdea97c&"
import script from "./115wsdbpfyh.vue?vue&type=script&lang=js&"
export * from "./115wsdbpfyh.vue?vue&type=script&lang=js&"
import style0 from "./115wsdbpfyh.vue?vue&type=style&index=0&id=4fdea97c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports